<mat-card class="padding">
  <mat-card-content>
    <div class="tab-content">
      <div class="scheduling-report-container">
        <div class="input-container">
          <div class="input-fields-wrapper">
            <div class="input-wrapper">
              <div class="row filtersection">
                <div class="col-lg-1 selected30">
                  <button mat-flat-button color="" class="btn-flat" [ngClass]="lastDays == '30' ? 'selected':''" (click)="last30Days()">{{'subscription.btn1' | translate}}</button>
                </div>
                <div class="col-lg-1 selected90">
                  <button mat-flat-button color="" class="btn-flat" [ngClass]="lastDays == '90' ? 'selected':''" (click)="last90Days()">{{'subscription.btn2' | translate}}</button>
                </div>
                <div class="col-lg-8 alignment date">
                  <span class="span">
                    {{'subscription.dateFrom' | translate}}
                  </span>
                  <mat-form-field class="example-full-width custom-date-picker" appearance="fill">
                    <input matInput placeholder="From Date" [matDatepicker]="picker" [(ngModel)]='startDate' readonly>
                    <mat-datepicker-toggle matSuffix [for]="picker" class="">
                      <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <span class="span">
                    {{'subscription.dateTo' | translate}}
                  </span>
                  <mat-form-field class="example-full-width-2 custom-date-picker" appearance="fill">
                    <input type="text" matInput placeholder="To Date" [matDatepicker]="picker1" [(ngModel)]='endDate' readonly>
                    <mat-datepicker-toggle matSuffix [for]="picker1">
                      <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                  </mat-form-field>
                  <!-- <span>
                    Stat Date
                  </span>
                  <input type="date" [ngModel]="startDate | date:'yyyy-MM-dd'" (ngModelChange)="startDate = $event"
                    class="w-25 margin-input form-control ng-pristine ng-untouched ng-valid">
                  <span>
                    End Date
                  </span>
                  <input type="date" [ngModel]="endDate | date:'yyyy-MM-dd'" (ngModelChange)="endDate = $event"
                    class="w-25 form-control ng-pristine ng-untouched ng-valid"> -->
                </div>
                <div class="col-lg-1 text-right alignment">
                  <button mat-flat-button color="" class="btn-primary " (click)="getAllData('search')">{{'subscription.btnSearch' | translate}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container mt-0">
          <table mat-table [dataSource]="credits" *ngIf="!noDataFound" matSort class="mat-elevation-z8">
            <ng-container matColumnDef="collectionname">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'subscription.TabCreditUsage.column1' | translate}}</th>
              <td mat-cell *matCellDef="let row"> {{row.collectionName}}</td>
            </ng-container>
            <ng-container matColumnDef="Testname">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'subscription.TabCreditUsage.column2' | translate}}</th>
              <td mat-cell *matCellDef="let row">{{row.testName}}</td>
            </ng-container>
            <ng-container matColumnDef="schedulename">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'subscription.TabCreditUsage.column3' | translate}}</th>
              <td mat-cell *matCellDef="let row">{{row.scheduleName}}</td>
            </ng-container>
            <ng-container matColumnDef="schedulestart&enddate">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'subscription.TabCreditUsage.column4' | translate}}</th>
              <td mat-cell *matCellDef="let row">{{row.scheduleDate}}</td>
            </ng-container>
            <ng-container matColumnDef="schedulelastupdatedby">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'subscription.TabCreditUsage.column5' | translate}}</th>
              <td mat-cell *matCellDef="let row">{{row.scheduleUpdatedBy}}</td>
            </ng-container>
            <ng-container matColumnDef="creditsused">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'subscription.TabCreditUsage.column6' | translate}}</th>
              <td mat-cell *matCellDef="let row">{{row.creditsUsed}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div class="data-not-found-container" *ngIf='noDataFound'>
            <p>{{'subscription.errorMsg' | translate}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="credits-paginator" [ngClass]="{'hidden': showPaginator === false}">
      <mat-paginator #paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons></mat-paginator>
    </div>
  </mat-card-content>
</mat-card>
